// extracted by mini-css-extract-plugin
export default {"ag-styles":"bf_y","toolbar":"bf_N5","controlsContainer":"bf_N6","controls":"bf_C","scrollIndicator":"bf_N7","videoTour":"bf_N8"};